import router from '@/router';

import { signIn, getAccount } from '@/api/account';

const state = {
  account: JSON.parse(window.localStorage.getItem('pixelcando-dealer')),
};

const getters = {
  info: (state) => state.account,
  countries: (state) => state.account?.countries,
  accessToken: (state) => state.account?.user?.accessToken,
  permissions: (state) => state.account?.permissions,
};

const mutations = {
  setAccount(state, account) {
    window.localStorage.setItem('pixelcando-dealer', JSON.stringify(account));

    state.account = account;
  },
  updateAccount(state, account) {
    window.localStorage.setItem(
      'pixelcando-dealer',
      JSON.stringify({
        ...state.account,
        ...account,
        user: {
          ...state.account.user,
          ...account.user,
        },
      })
    );

    state.account = {
      ...state.account,
      ...account,
      user: {
        ...state.account.user,
        ...account.user,
      },
    };
  },
};

const actions = {
  signIn({ commit }, { email, password }) {
    return signIn({ email, password })
      .then((account) => {
        commit('setAccount', account);

        router.push({ name: 'Dashboard' });
      })
      .catch((error) => {
        throw error;
      });
  },
  signOut({ commit }) {
    return new Promise((resolve, reject) => {
      try {
        commit('setAccount', null);

        router.push({ name: 'SignIn' });

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },
  getAccountInfo({ commit }) {
    return getAccount().then((account) => {
      commit('updateAccount', account);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
